import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { PessoaDTO } from '../../../models/clientes/pessoa.model';
import { PeriodoFiltro } from '../../../models/dashboard/periodo-filtro.model';
import { RelatorioContasPagasParams } from '../../../models/relatorios/relatorio-contas-pagas.model';
import { PessoaService } from '../../../services/pessoas/pessoas.service';
import { RelatorioContasPagasService } from '../../../services/relatorios/relatorio-contas-pagas.service';
import { calcularPeriodoPadraoRelatorio } from '../../../shared/utils/periodo-relatorio-padrao.util';
import { PRESETS_PERIODO_RELATORIO } from '../../../shared/utils/periodo.utils';
import { FileUtils } from '../../../shared/utils/file-utils';

@Component({
  selector: 'app-relatorio-contas-pagas',
  templateUrl: './relatorio-contas-pagas.component.html',
  styleUrls: ['./relatorio-contas-pagas.component.scss']
})
export class RelatorioContasPagasComponent implements OnInit {

  // Texto exibido no botao do filtro de periodo (app-periodo-filtro, modo avancado).
  periodoTexto = '';

  // Presets do filtro de periodo: lista padrao + "Mostrar todos" (so relatorios).
  readonly opcoesPeriodo = PRESETS_PERIODO_RELATORIO;

  // Parâmetros para o relatório
  params: RelatorioContasPagasParams = {
    tipoOperacaoFinanceira: 'SAIDA', // Fixo
    pessoaId: undefined,
    dataHoraInicial: '',
    dataHoraFinal: ''
  };

  // Lista de Pessoas
  pessoas: any[] = [];
  totalRecords: number = 0;
  first3: number = 0;
  searchNome: string = '';
  loadingPessoas: boolean = false;
  selectedPessoa: PessoaDTO | null = null;

  emitindoRelatorio: boolean = false;

  constructor(
    private translate: TranslateService,
    private relatorioService: RelatorioContasPagasService,
    private messageService: MessageService,
    private pessoaService: PessoaService,
  ) { }

  ngOnInit(): void {
    this.inicializarPeriodoPadrao();
    this.findPessoas();
  }

  // Inicializa o periodo padrao (Este mes) para que os params tenham datas
  // antes de o usuario abrir o dialog do filtro. O app-periodo-filtro nao
  // emite no init, entao replicamos o que o dashboard faz.
  private inicializarPeriodoPadrao(): void {
    this.aplicarPeriodo(calcularPeriodoPadraoRelatorio(this.translate));
  }

  // Handler do (periodoChanged) do app-periodo-filtro.
  onPeriodoChanged(periodo: PeriodoFiltro): void {
    this.aplicarPeriodo(periodo);
  }

  private aplicarPeriodo(periodo: PeriodoFiltro): void {
    this.params.dataHoraInicial = periodo.dataInicio;
    this.params.dataHoraFinal = periodo.dataFim;
    this.periodoTexto = periodo.texto;
  }

  findPessoas(page: number = 0, sort: string = 'id,asc') {
    const size = 10;
    let filter = '';

    filter += `&email=${this.searchNome}`;
    filter += `&nome=${this.searchNome}`;
    filter += `&fantasia=${this.searchNome}`;
    filter += `&ruc=${this.searchNome}`;
    filter += `&telefone=${this.searchNome}`;
    filter += `&ci=${this.searchNome}`;
    filter += `&nomeCidade=${this.searchNome}`;

    if (!isNaN(Number(this.searchNome))) {
      filter += `&codigoPessoa=${this.searchNome}`;
    }
    this.pessoaService
      .get('/pessoas/buscar', {
        page,
        size,
        sort,
        filter: `${filter ? `&${filter}` : ''}`,
      })
      .subscribe(
        (response: any) => {
          this.pessoas = response.content;
          this.totalRecords = response.totalElements;
          this.first3 = page * size;
        },
        (error: any) => {
          console.error('Erro ao buscar pessoas:', error);
          this.pessoas = [];
          this.totalRecords = 0;
        }
      );
  }

  onPessoaFilter(event: any) {
    this.searchNome = event.filter?.trim() || '';
    this.loadingPessoas = true;
    this.findPessoas();
    this.loadingPessoas = false;
  }

  // Botão "Emitir Relatório"
  emitirRelatorio(): void {
    this.emitindoRelatorio = true;

    // As datas ja foram aplicadas em params via onPeriodoChanged / periodo padrao.
    this.params.pessoaId = this.selectedPessoa ? this.selectedPessoa.id : undefined;

    // Chama o serviço
    this.relatorioService.emitirRelatorio(this.params).subscribe({
      next: (base64Pdf: string) => {
        FileUtils.abrirPdf(base64Pdf, 'relatorio-contas-pagas.pdf');
        this.emitindoRelatorio = false;
      },
      error: (err) => {
        console.error('Erro ao gerar relatório', err);
        this.emitindoRelatorio = false;

        if (err?.status === 404) {
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('common.aviso'),
            detail: this.translate.instant('relatorios.mensagens.nenhum_dado_encontrado'),
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('common.erro'),
            detail: this.translate.instant('relatorios.mensagens.erro_gerar_relatorio'),
          });
        }
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.ctrlKey && event.key === 'Enter' && !this.emitindoRelatorio) {
      event.preventDefault();
      this.emitirRelatorio();
    }
  }

}
